'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AXES_LIST = exports.AXES = exports.MIN_MAX_LIST = exports.MIN_MAX = exports.DIRECTIONS_LIST_VERTICAL = exports.DIRECTIONS_LIST_HORIZONTAL = exports.CORNERS_LIST = exports.DIRECTIONS_LIST = exports.CORNERS = exports.DIRECTIONS = undefined;

var _ramda = require('ramda');

var DIRECTIONS = exports.DIRECTIONS = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
});

var CORNERS = exports.CORNERS = Object.freeze({
  TOP_RIGHT: 'topRight',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_LEFT: 'bottomLeft',
  TOP_LEFT: 'topLeft'
});

var DIRECTIONS_LIST = exports.DIRECTIONS_LIST = (0, _ramda.values)(DIRECTIONS);
var CORNERS_LIST = exports.CORNERS_LIST = (0, _ramda.values)(CORNERS);

var DIRECTIONS_LIST_HORIZONTAL = exports.DIRECTIONS_LIST_HORIZONTAL = [DIRECTIONS.LEFT, DIRECTIONS.RIGHT];

var DIRECTIONS_LIST_VERTICAL = exports.DIRECTIONS_LIST_VERTICAL = [DIRECTIONS.TOP, DIRECTIONS.BOTTOM];

var MIN_MAX = exports.MIN_MAX = {
  MIN: 'min',
  MAX: 'max'
};

var MIN_MAX_LIST = exports.MIN_MAX_LIST = (0, _ramda.values)(MIN_MAX);

var AXES = exports.AXES = {
  X: 'x',
  Y: 'y'
};

var AXES_LIST = exports.AXES_LIST = (0, _ramda.values)(AXES);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/expanders.js
// module id = 66
// module chunks = 168707334958949